var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "invoice-add-wrapper" },
    [
      _c(
        "b-row",
        { staticClass: "invoice-add" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", xl: "9", md: "8" } },
            [
              _c(
                "b-card",
                {
                  staticClass: "invoice-preview-card px-2",
                  staticStyle: { display: "block", width: "100%" },
                  attrs: { "no-body": "", id: "invoice-preview-card" },
                },
                [
                  _c("b-card-body", {}, [
                    _c("div", { staticClass: "row align-items-center mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-1 col-1" },
                        [_c("Logo")],
                        1
                      ),
                      _c("div", { staticClass: "col-9" }, [
                        _c("div", {}, [_c("CompanyName")], 1),
                        _c("div", {}, [_c("Address")], 1),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-6 mb-3 mb-lg-0" },
                        [
                          _c("h4", { staticClass: "mb-1" }, [
                            _vm._v("Customer"),
                          ]),
                          _c("ClientAddress", {
                            attrs: { client: _vm.whenSelected },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-lg-6 text-left text-lg-right mt-3 mt-lg-0",
                        },
                        [
                          _c("h4", [
                            _vm._v(" Quotation "),
                            _c("span", { staticClass: "invoice-number" }, [
                              _vm._v("#" + _vm._s(_vm.quotationId.quotationNo)),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "text-left text-lg-right" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row invoice-date-wrapper justify-content-lg-end mb-2",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-lg-6 d-flex justify-content-between justify-content-lg-end mb-2 mb-lg-0",
                                    },
                                    [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(" Date: "),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-lg-6 d-flex justify-content-lg-end",
                                    },
                                    [
                                      _c("flat-pickr", {
                                        staticClass:
                                          "form-control invoice-edit-input w-100",
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.quotationId.createdOn,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.quotationId,
                                              "createdOn",
                                              $$v
                                            )
                                          },
                                          expression: "quotationId.createdOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "row invoice-date-wrapper mb-2",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-lg-7 d-flex justify-content-between justify-content-lg-end mb-2 mb-lg-0",
                                    },
                                    [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(" Due Date: "),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-lg-5 d-flex justify-content-lg-end",
                                    },
                                    [
                                      _c("flat-pickr", {
                                        staticClass:
                                          "form-control invoice-edit-input w-100",
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.quotationId.dueDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.quotationId,
                                              "dueDate",
                                              $$v
                                            )
                                          },
                                          expression: "quotationId.dueDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              this.vat
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row invoice-date-wrapper mb-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-lg-7 d-flex justify-content-between justify-content-lg-end mb-2 mb-lg-0",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "invoice-date-title",
                                            },
                                            [_vm._v("VAT:")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-lg-5 d-flex justify-content-lg-end",
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "invoice-date" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(this.vat) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              this.vat
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row invoice-date-wrapper mb-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-lg-7 d-flex justify-content-between justify-content-lg-end mb-2 mb-lg-0",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "invoice-date-title",
                                            },
                                            [_vm._v("BRN Number:")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-lg-5 d-flex justify-content-lg-end",
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "invoice-date" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(this.brn) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("b-card-body", [
                    _c(
                      "div",
                      { staticClass: "table-responsive-wrapper" },
                      [
                        _c("b-table", {
                          staticClass: "mb-0",
                          attrs: {
                            responsive: "",
                            bordered: "",
                            fields: _vm.dynamicFields,
                            items: _vm.quotationId.quotationItems,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "cell(productImg)",
                              fn: function (data) {
                                return [
                                  data.item.itemId
                                    ? [
                                        _c("img", {
                                          staticClass: "product-image",
                                          attrs: {
                                            src:
                                              _vm.baseUrl +
                                              "selfservices/getproductimage?ProductID=" +
                                              data.item.itemId,
                                            alt: "Product Image",
                                          },
                                          on: {
                                            error: function ($event) {
                                              return _vm.showNoImage($event)
                                            },
                                          },
                                        }),
                                      ]
                                    : [_c("span", [_vm._v("-")])],
                                ]
                              },
                            },
                            {
                              key: "cell(cost)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.currencySymbol) +
                                      " " +
                                      _vm._s(
                                        parseFloat(data.item.cost).toFixed(2)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(qty)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        parseFloat(data.item.quantity).toFixed(
                                          5
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(VAT)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        data.item.tax
                                          ? parseFloat(data.item.tax).toFixed(2)
                                          : 0
                                      ) +
                                      " % "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(discount)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (data.item.discount === null
                                          ? 0
                                          : data.item.discount
                                        ).toFixed(2)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm.HasPermission(_vm.PermissionList.Sales_Finance)
                    ? _c(
                        "b-card-body",
                        {},
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mt-md-0 mt-3",
                                  attrs: {
                                    cols: "12",
                                    md: "6",
                                    order: "2",
                                    "order-md": "1",
                                  },
                                },
                                [
                                  _c("b-card-text", { staticClass: "mb-0" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Salesperson :")]
                                    ),
                                    _c("span", { staticClass: "ml-75" }, [
                                      _vm._v(_vm._s(this.genSP) + " "),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "mt-md-6 d-flex justify-content-end",
                                  attrs: {
                                    cols: "12",
                                    md: "6",
                                    order: "1",
                                    "order-md": "2",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "invoice-total-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "invoice-total-item" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-title",
                                            },
                                            [_vm._v("Subtotal:")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-amount",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.currencySymbol) +
                                                  " " +
                                                  _vm._s(
                                                    parseFloat(
                                                      _vm.quotationId.subTotal
                                                    ).toFixed(2)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.quotationId.discount > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Discount")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.quotationId
                                                            .discount
                                                        ).toFixed(2)
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.vat
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("VAT")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.quotationId.tax
                                                        ).toFixed(2)
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("hr", { staticClass: "my-50" }),
                                      _c(
                                        "div",
                                        { staticClass: "invoice-total-item" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-title",
                                            },
                                            [_vm._v("Total:")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-amount",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.currencySymbol) +
                                                  " " +
                                                  _vm._s(
                                                    parseFloat(
                                                      _vm.quotationId.total
                                                    ).toFixed(2)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("hr", { staticClass: "invoice-spacing" }),
                  _c(
                    "b-card-body",
                    { staticClass: "invoice-padding pt-0 px-0" },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v("Note: "),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.quotationId.notes))]),
                    ]
                  ),
                  _c("div", { staticClass: "row" }),
                  _c("div", { staticClass: "row mt-3 signature-section" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-6 col-lg-4 mb-3 mb-lg-0" },
                      [
                        _c("h4", { staticClass: "text-center" }, [
                          _vm._v("Received By:"),
                        ]),
                        _c("p", { staticClass: "text-center" }),
                        _c("p", { staticClass: "text-center signature-line" }),
                        _c("p", { staticClass: "text-center" }),
                        _c("p", { staticClass: "text-center" }),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-6 col-lg-4 mb-3 mb-lg-0" },
                      [
                        _c("h4", { staticClass: "text-center" }, [
                          _vm._v("Sent By:"),
                        ]),
                        _c("p", { staticClass: "text-center" }),
                        _c("p", { staticClass: "text-center signature-line" }),
                        _c("p", { staticClass: "text-center" }),
                        _c("p", { staticClass: "text-center" }),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-6 col-lg-4 mb-3 mb-sm-0" },
                      [
                        _c("h4", { staticClass: "text-center" }, [
                          _vm._v("Delivered By:"),
                        ]),
                        _c("p", { staticClass: "text-center" }),
                        _c("p", { staticClass: "text-center signature-line" }),
                        _c("p", { staticClass: "text-center" }),
                        _c("p", { staticClass: "text-center" }),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "invoice-actions",
              attrs: { cols: "12", md: "4", xl: "3" },
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(186, 191, 199, 0.15)",
                          expression: "'rgba(186, 191, 199, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "mb-75",
                      attrs: { variant: "outline-secondary", block: "" },
                      on: { click: _vm.printQuotation },
                    },
                    [_vm._v(" Print / Download ")]
                  ),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(113, 102, 240, 0.15)",
                          expression: "'rgba(113, 102, 240, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "mb-1",
                      attrs: { variant: "outline-primary", block: "" },
                      on: {
                        click: function ($event) {
                          return _vm.handleDocBtn(_vm.quotationId.id)
                        },
                      },
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(" Documents "),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "3" },
                    },
                    [
                      _c(
                        "b-modal",
                        {
                          ref: "modal-view-quote-document",
                          attrs: {
                            id: "modal-view-quote-document",
                            "ok-only": "",
                            "ok-title": "View",
                            centered: "",
                            size: "lg",
                            title: "View Quote Documents",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("DocumentUpload", {
                            attrs: { documentDetails: _vm.documentDetails },
                            on: {
                              deleteFile: _vm.deleteFile,
                              downloadFile: _vm.downloadFile,
                              uploadFiles: _vm.uploadFiles,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.whenSelected.tel && _vm.tenant
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(186, 191, 199, 0.15)",
                              expression: "'rgba(186, 191, 199, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mb-75",
                          attrs: { variant: "info", block: "" },
                          on: { click: _vm.openWhatsApp },
                        },
                        [
                          _c("img", {
                            staticClass: "w-10",
                            attrs: {
                              src: require("@/assets/images/logo/whatsapp.png"),
                            },
                          }),
                          _vm._v(" Whatsapp "),
                        ]
                      )
                    : _vm._e(),
                  _vm.quotationId.status != 3
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(186, 191, 199, 0.15)",
                              expression: "'rgba(186, 191, 199, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mb-75",
                          attrs: { variant: "primary", block: "" },
                          on: { click: _vm.convertProforma },
                        },
                        [_vm._v(" Convert to Proforma ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "modal-addWarehouse", centered: "" },
          on: { hide: _vm.onModalHide },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    { on: { click: _vm.continueConvertProforma } },
                    [_vm._v("Okay")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showAddWarehouseModal,
            callback: function ($$v) {
              _vm.showAddWarehouseModal = $$v
            },
            expression: "showAddWarehouseModal",
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "text-nowrap mr-50",
              attrs: { for: "invoice-data-sales-person" },
            },
            [_vm._v("Choose Warehouse:")]
          ),
          _c("b-form-select", {
            attrs: { options: _vm.optionsWarehouse },
            model: {
              value: _vm.warehouseId,
              callback: function ($$v) {
                _vm.warehouseId = $$v
              },
              expression: "warehouseId",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }